<template>
  <div class="faceForm">
    <img class="faceBg" src="@/assets/imgs/faceBg.png" alt="" />
    <div class="form">
      <div class="title">身份验证</div>
      <div class="info">
        <div>
          姓名：<span>{{ formData.userName }}</span>
        </div>
        <div>
          身份证号码：
          <span>{{ idCardNo }}</span>
        </div>
      </div>
      <div class="tag">
        为了满足合规要求，在使用人脸识别服务前，需要您授权其查询如下信息:
      </div>
      <div class="tips">
        <div>查询您的人脸照片</div>
        <div>提供您的身份信息及录制的视频截图</div>
      </div>
    </div>
    <div class="footer">
      <van-button type="primary" block @click="goNext">同意并签署</van-button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {}
    },
    computed: {
      ...mapState({
        formData: state => state.authentication,
      }),
      idCardNo() {
        return `${this.formData.idCardNo.slice(
          0,
          2
        )}**************${this.formData.idCardNo.slice(
          this.formData.idCardNo.length - 2,
          this.formData.idCardNo.length
        )}`
      },
    },
    created() {},
    methods: {
      goNext() {
        // this.$router.push('/authentication/face/faceSecond')
        // const u = navigator.userAgent
        // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 判断是否是 android终端
        // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 判断是否是 iOS终端
        // if (isIOS) {
        //   this.$router.push('/authentication/face/faceSecond')
        // } else if (isAndroid) {
        //   this.$router.push('/authentication/face/faceSecondAndroid')
        // } else {
        //   this.$router.push('/authentication/face/faceSecond')
        // }

        this.$router.push('/authentication/face/faceSecondAndroid')
      },
    },
  }
</script>
<style lang="less" scoped>
  .faceForm {
    position: relative;
    .faceBg {
      width: 100%;
      margin-bottom: 20px;
    }
    .form {
      padding: 0 17px;
      .title {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: bold;
        text-align: left;
        color: #111a34;
        line-height: 22px;
        margin-bottom: 12px;
      }
      .info {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #677283;
        line-height: 26px;
        margin-bottom: 24px;
        span {
          color: #111a34;
        }
      }
      .tag {
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #677283;
        line-height: 24px;
        margin-bottom: 4px;
      }
      .tips {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #111a34;
        line-height: 26px;
        & > div {
          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 4px;
            height: 4px;
            opacity: 1;
            background: #1676ff;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .footer {
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      padding: 16px;
      box-sizing: border-box;
    }
  }
</style>
